import React from "react"

const Footer = () => {
  return (
    <section className="footer">
      <div className="container">
        <div className="footer__content">
          <div className="footer__left">
            <div className="footer__links">
              <a
                href="https://twitter.com/doordash"
                target="_blank"
                className="footer__links--item"
              >
                Twitter
              </a>

              <a
                href="https://www.facebook.com/DoorDash"
                target="_blank"
                className="footer__links--item"
              >
                Facebook
              </a>
            </div>
          </div>

          <div className="footer__logo">
            <a href="/">
              <img
                src="./footer-logo.svg"
                alt="Footer Logo"
                className="footer__logo--image"
              />
            </a>
          </div>

          <div className="footer__right">
            <div className="footer__links">
              <a
                href="https://www.instagram.com/doordash"
                target="_blank"
                className="footer__links--item"
              >
                Instagram
              </a>

              <a
                href="https://www.linkedin.com/company/doordash/"
                target="_blank"
                className="footer__links--item"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        <div className="footer__production">
          <div className="footer__production-logo">
            <a href="https://happily.io" target="_blank">
              <img src="./happily-logo.svg" />
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer
